// 文件下载和图片预览
import Vue from 'vue'
import dialog from '@/views/form/components/render/ImgViewer.vue'

// 使用extend继承创建组件
const Cmp = Vue.extend(dialog)

export default new Cmp().$mount()
